"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const getDisplayRoundNumber_1 = __importDefault(require("./getDisplayRoundNumber"));
// 會把 setItems 也 format status
function getFormatBatchItemStatus(item) {
    const discount = [];
    if (item.discount != null && item.discount !== 0) {
        // 後台設定的餐點折扣
        discount.push(`-${getDisplayRoundNumber_1.default(item.discount)}$`);
    }
    // 組合每一個變價字串
    const modifierDiscounts = [];
    if (item.modifiers != null) {
        item.modifiers.forEach(modifier => {
            let discountText = '';
            if (modifier.name != null) {
                // 有名字時顯示名字
                discountText += modifier.name;
            }
            if (modifier.amount !== 0) {
                // 顯示更動金額
                discountText += getDisplayRoundNumber_1.default(modifier.amount) + '$';
            }
            if (modifier.percent !== 0) {
                // 顯示更動百分比
                discountText += String(modifier.percent) + '%';
            }
            modifierDiscounts.push(discountText);
        });
    }
    const status = lodash_1.default.concat(discount, item.options.map(option => option.name), item.tags.map(tag => tag.name), item.remarks.filter(o => !lodash_1.default.isEmpty(o)), modifierDiscounts);
    return item.cancelled ? '已取消' : status.join('/');
}
exports.default = getFormatBatchItemStatus;
//# sourceMappingURL=getFormatBatchItemStatus.js.map